export default "__VITE_ASSET__DPsyA3xy__"